import { useEffect, useState } from "react";
import { Settings, Sparkles } from "lucide-react";
import QuickStatCard from "../../components/marketing/cloud-dashboard/quick-stat";
import Channel from "../../components/marketing/cloud-dashboard/channel";
import CommunicationChannels from "../../components/marketing/cloud-dashboard/channel";
import CreateProfileModal from "../auth/create-profile";
import ConvoHubPlatformModal from "../cpas-platform";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserResponse } from "../../components/types";
import useRequest from "../../components/hook/use-req";

interface Channel {
  id: string;
  label: string;
  status: 'active' | 'setup' | 'inactive';
  path: string;
}

const CPaaSDashboard = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState<string | null>(null);
  const [createProfileModal, setCreateProfileModal] = useState(true);
  const [showPlatform, setShowPlatform] = useState(false);
  const [user, setUser] = useState<UserResponse | null>(null);
  const [searchParams] = useSearchParams();
const firstNameParam = searchParams.get("first_name");
  const [stats] = useState({
    totalMessages: 0,
    voiceCalls: 0,
    aiInteractions: 0,
    countries: 0,
  });

useEffect(() => {
  const hashToken = window.location.hash.replace("#", "");
  const storedToken = localStorage.getItem("authToken");

  if (hashToken) {
    localStorage.setItem("authToken", hashToken);
    setToken(hashToken);
  } else if (storedToken) {
    setToken(storedToken);
  } else {
    navigate("/login"); // redirect properly
  }
}, [navigate]);

  const { makeRequest: getUserData } = useRequest(
    `/auth/get_userdata`,
    "GET",
    { Authorization: `Bearer ${token}` }
  );

  useEffect(() => {
  if (firstNameParam) {
    setCreateProfileModal(true);
    setShowPlatform(false);
  } else {
    setCreateProfileModal(false);
    setShowPlatform(true);
  }
}, [firstNameParam]);

useEffect(() => {
  if (!token) return;

  const fetchData = async () => {
    const [response] = await getUserData();
    setUser(response);
  };

  fetchData();
}, [token]);



  const [channels] = useState<Channel[]>([
    { id: 'sms', label: 'SMS', status: 'active', path: '/dashboard' },
    { id: 'whatsapp', label: 'WhatsApp', status: 'active', path: '/whatsapp-setup' },
    { id: 'email', label: 'Email', status: 'active', path: '/email' },
    { id: 'rcs', label: 'RCS', status: 'setup', path: '/rcs-setup' },
    { id: 'voice', label: 'Voice', status: 'active', path: '/voice' },
    { id: 'webchat', label: 'Web Chat', status: 'setup', path: '/webchat-setup' },
    { id: 'telegram', label: 'Telegram', status: 'inactive', path: '/telegram-setup' }
  ]);

  const handleChannelClick = (channelId: string) => {

    // Handle channel click logic here
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md border-b border-slate-200 shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center">
                <Sparkles className="w-6 h-6 text-white" />
              </div>
              <div>
                <h1 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
                  ConvoHub
                </h1>
                <p className="text-sm text-slate-500">
                  AI-Powered Communication Platform
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <button className="p-2 hover:bg-slate-100 rounded-lg transition-colors">
                <Settings className="w-5 h-5 text-slate-600" />
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Hero Section */}
        <div className="mb-12">
          {/* Quick Stats */}
          <QuickStatCard {...stats} />
        </div>

        <CommunicationChannels
          channels={channels}
          onChannelClick={handleChannelClick}
        />
      </div>

      <ConvoHubPlatformModal
        isOpen={showPlatform}
        onClose={() => setShowPlatform(false)}
        token={token ?? undefined}
        onNavigate={(path) => {
          setShowPlatform(false);
          navigate(path);
        }}
      />
    </div>
  );
};

export default CPaaSDashboard;
